// /utils/detectPlatform.js

export function detectPlatform(url) {
    if (!url) return 'unknown';
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('youtu.be') || lowerUrl.includes('youtube.com')) {
      // YouTube Shorts typically have "/shorts/" in the URL.
      return lowerUrl.includes('/shorts/') ? 'youtubeShorts' : 'youtube';
    }
    if (lowerUrl.includes('tiktok.com')) {
      return 'tiktok';
    }
    // Instagram also produces /share/reel/ and /share/p/ URLs. Treat every
    // Instagram URL as Instagram so shared links keep their platform label and
    // can still use the provider's embed/fallback behavior.
    if (lowerUrl.includes('instagram.com')) {
      return 'instagram';
    }
    return 'unknown';
  }
  
